import { createContext, useContext } from 'react'

// Every filter value, not only the ones the searched state offers. The search
// page loads it on the server. Pages without it (e.g. SE-friendly) get `null`.
export const AllFiltersContext = createContext<GroupedProviderFilter | null>(
  null
)

export const useAllFilters = (): GroupedProviderFilter | null =>
  useContext(AllFiltersContext)

type AllFiltersProviderProps = {
  allGroupedFilters: GroupedProviderFilter
}

const AllFiltersProvider: React.FC<AllFiltersProviderProps> = ({
  children,
  allGroupedFilters,
}) => (
  <AllFiltersContext.Provider value={allGroupedFilters}>
    {children}
  </AllFiltersContext.Provider>
)

export default AllFiltersProvider
